import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { TINYMCE_LIST_CONFIG } from 'app/shared/editor-config';
import { BulletinService } from 'app/_services/bulletin.service';
import { DialogsService } from 'app/_services/dialogs/dialogs.service';
import { NotificationService } from 'app/_services/notification.service';
import { ToolsService } from 'app/_services/tools.service';
import { UserService } from 'app/_services/user.service';
import { Subscription } from 'rxjs';
import { Bulletin, BulletinVM, BulletinCityVM, BulletinSchoolVM, GradeLevels } from './bulletin';
import { EditBulletinDialogComponent } from './edit-bulletin/edit-bulletin.component';

@Component({
  selector: 'app-bulletin',
  templateUrl: './bulletin.component.html',
  styleUrls: ['../shared/table-defaults.scss', './bulletin.component.scss', '../../assets/css/bulletin/bulletin-base.css']
})
export class BulletinComponent implements OnInit, OnDestroy {
  latestBulletin: string;
  latestBulletinIsLive: boolean;
  icon = 'info';
  type = 'info';
  arialabel = 'Message icon';
  message = '';
  defaultMessage = `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text 
    ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived 
    not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 
    1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like 
    Aldus PageMaker including versions of Lorem Ipsum.`;
  liveBulletin: string;
  bulletins: BulletinVM[] = [];
  bulletin: BulletinVM;
  cities: BulletinCityVM[] = [];
  schools: BulletinSchoolVM[] = [];
  loadingEditor = true;
  config = TINYMCE_LIST_CONFIG;
  private subscription: Subscription = new Subscription();

  dataSource: MatTableDataSource<BulletinVM>;
  displayedColumns: string[] = ['Details', 'type', 'duration', 'bulletinSchoolCount', 'active', 'bulletinLive', 'actions'];
  columnsToDisplay = this.displayedColumns.slice();

  @ViewChild(MatTable) table: MatTable<BulletinVM>;

  constructor(
    private userService: UserService,
    private bulletinService: BulletinService,
    private dialog: MatDialog,
    private dialogSerivce: DialogsService,
    private toolsService: ToolsService,
    public notificationService: NotificationService
    ) { 
    }

  ngOnInit(): void {
    this.subscription.add(this.getBulletins());
    this.subscription.add(this.getCities());
    this.subscription.add(this.getSchools());
    this.subscription.add(this.getLatestBulletinFromAPI());
    const user = this.userService.UserValue;
    
    setTimeout((_ => this.loadingEditor = false), 500)
    
  }

  loadDatasource(data: BulletinVM[]): void {
      this.dataSource = new MatTableDataSource(data);
  }

  getBulletins() {
    return this.bulletinService.getBulletins().subscribe(b => {
        this.bulletins = b;
        this.loadDatasource(this.bulletins);
    });
  }

  getBulletin(id: number) {
    return this.bulletinService.getBulletinById(id).subscribe((data: BulletinVM) => this.bulletin = data);
  }

  getLatestBulletinFromAPI() {
    return this.bulletinService.getLatestBulletinFromAPI('0000').subscribe((bulletin) => {
        if (bulletin) {
            this.liveBulletin = bulletin;
        }
        else { 
            this.liveBulletin = '<p>No live bulletins found</p>' 
        };
    });
  }

  getCities() {
    return this.bulletinService.getDistinctCities().subscribe(res => {
        res.forEach((city: any) => {
            this.cities.push( {city: city, checked: false} as BulletinCityVM )
        });
    });
  }

  getSchools() {
    return this.bulletinService.getBulletinsSchools().subscribe( s => {
        this.schools = s;
    });
  }

  newBulletin(): BulletinVM {
      return this.bulletin = {
          bulletinId: 0,
          message: '',
          type: '',
          startDate: '',
          endDate: '',
        //   startTime: '',
        //   endTime: '',
          dateCreated: '',
          dateUpdated: '',
          updatedBySapid: '',
          active: true,
          title: '',
          link: '',
          bulletinSchool: null,
          schools: this.schools,
          cities: this.cities,
          gradeLevels: GradeLevels,
          allSchools: true,
          byGradeLevel: false,
          byCity: false,
          bySchool: false,
          bulletinSchoolCount: null,
          bulletinLive: false,
      };
  }

  openEditBulletinDialog(bulletin: BulletinVM, dialogTitle: string, creating: boolean = false): MatDialogRef<EditBulletinDialogComponent> {
      const self = this;
      const cities = self.cities;
      const schools = self.schools;
      const config: MatDialogConfig = {
          width: '90vw',
          panelClass: 'bulletinEditor',
          data: { bulletin, cities, creating, dialogTitle, schools },
      };

      return self.dialog.open(EditBulletinDialogComponent, config);
  }

  addBulletin(): void {
      const user = this.userService.UserValue;
      const title = 'Add New Bulletin';
      const bulletins = this.bulletins;

      const bulletin = this.newBulletin();

      const dialogResult = this.openEditBulletinDialog(bulletin, title, true);

      dialogResult.afterClosed().subscribe((result: BulletinVM) => {
        if (!result) {
            return;
        }
        
        result.dateCreated = this.toolsService.toISOLocal(new Date());
        result.updatedBySapid = user.sapid.toString();
          
        this.bulletinService.createBulletin(result).subscribe(response => {
            response.bulletinLive = this.bulletinService.isBulletinLive(response);
            bulletins.push(response);
            this.loadDatasource(bulletins);
        });

          this.notificationService.showSuccess(`New Bulletin has been added.`);
      });
  }

  editBulletin(bulletin: BulletinVM): void {
      const title = 'Edit Bulletin';
      const user = this.userService.UserValue;

      this.bulletinService.getBulletinById(bulletin.bulletinId).subscribe(data => {

          const dialogResult = this.openEditBulletinDialog(data, title);
          dialogResult.afterClosed().subscribe((result: BulletinVM) => {
              if (!result) {
                  return;
              }

              result.updatedBySapid = user.sapid.toString();
              
              this.bulletinService.updateBulletin(result.bulletinId, result).subscribe((res: Bulletin) => {
                  bulletin.message = res.message
                  bulletin.type = res.type
                  bulletin.startDate = res.startDate
                  bulletin.endDate = res.endDate
                  bulletin.dateUpdated = res.dateUpdated
                  bulletin.updatedBySapid = res.updatedBySapid
                  bulletin.active = res.active
                  bulletin.title = res.title
                  bulletin.link = res.link
                  bulletin.bulletinSchool = res.bulletinSchool

                  bulletin.bulletinLive = this.bulletinService.isBulletinLive(res);

                  this.notificationService.showSuccess(`Bulletin has been updated.`);
              });
          });
      });

  }

  deleteBulletin(bulletin: BulletinVM): void {
      const dialogResult$ = this.dialogSerivce.OpenConfirmationDialog({
          TitleText: 'Delete Bulletin',
          MessageText: 'Are you sure you want to delete this emergency bulletin?',
          OKText: 'Yes, remove bulletin',
          CancelText: 'No',
      });

      dialogResult$.subscribe((result) => {
          if (!result) {
              return;
          }

          const index = this.dataSource.data.indexOf(bulletin, 0);

          if (index > -1) {
              this.dataSource.data.splice(index, 1);
          }

          this.bulletinService.deleteBulletin(bulletin.bulletinId).subscribe();
          this.table.renderRows();

          this.notificationService.showSuccess(`Bulletin have been removed.`);
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}